import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lot-number-editor-modal"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "editor-grid" }
const _hoisted_5 = { class: "editor-section" }
const _hoisted_6 = { class: "section-title" }
const _hoisted_7 = { class: "control-group" }
const _hoisted_8 = { class: "control-input" }
const _hoisted_9 = { class: "value-display" }
const _hoisted_10 = { class: "control-group" }
const _hoisted_11 = { class: "control-input" }
const _hoisted_12 = { class: "value-display" }
const _hoisted_13 = { class: "control-group" }
const _hoisted_14 = { class: "control-input" }
const _hoisted_15 = { class: "value-display" }
const _hoisted_16 = { class: "control-group" }
const _hoisted_17 = { class: "control-input" }
const _hoisted_18 = { class: "value-display" }
const _hoisted_19 = { class: "control-group toggle-group" }
const _hoisted_20 = { class: "toggle-switch" }
const _hoisted_21 = ["id"]
const _hoisted_22 = ["for"]
const _hoisted_23 = { class: "editor-section preview-section" }
const _hoisted_24 = {
  key: 0,
  class: "preview-container"
}
const _hoisted_25 = ["cx", "cy"]
const _hoisted_26 = ["x", "y", "transform", "font-size"]
const _hoisted_27 = { class: "modal-footer" }
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-overlay",
          onClick: _withModifiers($setup.handleClose, ["self"])
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", { class: "modal-header" }, [
            _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Edit Lot Number", -1)),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: $setup.handleClose
            }, "✕")
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, "Lot Number: " + _toDisplayString($props.lotNumber), 1),
                _createElementVNode("div", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "control-label" }, "Position X Offset", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      class: "slider",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.localMetadata.offsetX) = $event)),
                      type: "range",
                      min: "-50",
                      max: "50",
                      step: "1"
                    }, null, 512), [
                      [
                        _vModelText,
                        $setup.localMetadata.offsetX,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString($setup.localMetadata.offsetX) + " px", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", { class: "control-label" }, "Position Y Offset", -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      class: "slider",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.localMetadata.offsetY) = $event)),
                      type: "range",
                      min: "-50",
                      max: "50",
                      step: "1"
                    }, null, 512), [
                      [
                        _vModelText,
                        $setup.localMetadata.offsetY,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_12, _toDisplayString($setup.localMetadata.offsetY) + " px", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "control-label" }, "Scale (Size)", -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      class: "slider",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.localMetadata.scale) = $event)),
                      type: "range",
                      min: "0.1",
                      max: "4",
                      step: "0.1"
                    }, null, 512), [
                      [
                        _vModelText,
                        $setup.localMetadata.scale,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_15, _toDisplayString($setup.localMetadata.scale.toFixed(1)) + "x", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "control-label" }, "Rotation", -1)),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      class: "slider",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.localMetadata.rotation) = $event)),
                      type: "range",
                      min: "0",
                      max: "360",
                      step: "1"
                    }, null, 512), [
                      [
                        _vModelText,
                        $setup.localMetadata.rotation,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_18, _toDisplayString($setup.localMetadata.rotation) + "°", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "control-label" }, "Display", -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      class: "toggle-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.localMetadata.displayed) = $event)),
                      type: "checkbox",
                      id: `display-toggle-${$props.lotId}`
                    }, null, 8, _hoisted_21), [
                      [_vModelCheckbox, $setup.localMetadata.displayed]
                    ]),
                    _createElementVNode("label", {
                      class: "toggle-label",
                      for: `display-toggle-${$props.lotId}`
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("span", { class: "toggle-slider" }, null, -1)
                    ]))], 8, _hoisted_22)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "section-title" }, "Preview", -1)),
                ($setup.previewViewBox)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: "preview-svg",
                        viewBox: $setup.previewViewBox,
                        preserveAspectRatio: "xMidYMid meet"
                      }, [
                        _cache[12] || (_cache[12] = _createElementVNode("rect", {
                          class: "preview-lot-bg",
                          x: "50",
                          y: "50",
                          width: "200",
                          height: "150",
                          fill: "#e8f0d8",
                          stroke: "#888",
                          "stroke-width": "2"
                        }, null, -1)),
                        _createElementVNode("circle", {
                          class: "preview-center-marker",
                          cx: $setup.previewCenterX,
                          cy: $setup.previewCenterY,
                          r: "3",
                          fill: "#ff0000"
                        }, null, 8, _hoisted_25),
                        ($setup.localMetadata.displayed)
                          ? (_openBlock(), _createElementBlock("text", {
                              key: 0,
                              class: "preview-lot-number",
                              x: $setup.previewCenterX,
                              y: $setup.previewCenterY,
                              transform: $setup.previewTransform,
                              "text-anchor": "middle",
                              "dominant-baseline": "middle",
                              "font-size": $setup.previewFontSize
                            }, _toDisplayString($props.lotNumber), 9, _hoisted_26))
                          : _createCommentVNode("", true)
                      ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              class: "btn-secondary",
              onClick: $setup.handleClose
            }, "Cancel"),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: $setup.handleSave,
              disabled: $setup.saving
            }, _toDisplayString($setup.saving ? "Saving..." : "Save Changes"), 9, _hoisted_28)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}